import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import defaultImage from '../../images/img-default.svg';

import { ArrowRepeat } from 'react-bootstrap-icons';

import { uploadMedia } from '../../global/helpers';

export const ContribAccountEdit = () => {
  const dispatch = useDispatch();

  const [image, setImage] = useState();
  const [imageFile, setImageFile] = useState('');
  const [imageGuid, setImageGuid] = useState('');

  useEffect(() => {
    const formData = new FormData();
    formData.append('file', imageFile);
    uploadMedia(formData).then((resp) => setImageGuid(resp.data.guid));
  }, [imageFile]);

  const handlePostImage = async (e) => {
    setImageFile(e.target.files[0]);
    setImage(URL.createObjectURL(e.target.files[0]));
  };

  useEffect(() => {
    dispatch({ type: 'SET_IS_BREADCRUMB_SHOWN', payload: { isBreadcrumbShown: true } });
  }, [dispatch]);

  console.log('image guid', imageGuid);
  return (
    <div
      className='p-3 p-md-5 bg-white shadow d-flex justify-content-center'
      style={{ width: '100%' }}
    >
      <div style={{ width: '70%' }}>
        <div className='d-flex flex-column align-items-center d-md-block'>
          <img style={{ width: '150px' }} src={image ? image : defaultImage} alt='profile' />
          <label
            className='ml-md-5 ml-2 cursor-pointer tracking-normal text-sm mt-4 mt-md-0'
            style={{ color: '#7CB1FF' }}
            htmlFor='profile-image'
          >
            <ArrowRepeat />
            <span className='ml-2 '>Replace Image</span>
          </label>
          <input type='file' className='d-none' id='profile-image' onChange={handlePostImage} />
        </div>
        <form className='mt-md-5 mt-2'></form>
      </div>
    </div>
  );
};
